export function isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || '';
    const mobileUA = /android.*mobile|iphone|ipod|blackberry|iemobile|opera mini|windows phone/i.test(userAgent);
    const narrowScreen = window.innerWidth <= 768;
    return mobileUA && narrowScreen;
}

export function isIOSDevice(): boolean {
    return /iphone|ipod/i.test(navigator.userAgent || '');
}

export function isAndroidDevice(): boolean {
    return /android/i.test(navigator.userAgent || '');
}
